export default {
  mode: {
    light: "Hell",
    dark: "Dunkel"
  },
  
  guide: {
    title: "Thema-Leitfaden"
  },
  
  colors: {
    title: "Farben",
    primary500: "Primär 500",
    primary600: "Primär 600", 
    primary700: "Primär 700",
    secondary500: "Sekundär 500",
    success: "Erfolg",
    warning: "Warnung",
    error: "Fehler",
    background: "Hintergrund",
    surface: "Oberfläche",
    card: "Karte"
  },
  
  typography: {
    title: "Typografie",
    h1: "Überschrift 1",
    h1Font: "Text 4xl Serif",
    h2: "Überschrift 2", 
    h2Font: "Text 3xl Serif",
    h3: "Überschrift 3",
    h3Font: "Text 2xl Serif",
    body: "Fließtext",
    bodyFont: "Text base",
    small: "Kleiner Text",
    smallFont: "Text sm"
  },
  
  components: {
    title: "Komponenten",
    
    buttons: {
      title: "Schaltflächen",
      default: "Standard",
      outline: "Umriss",
      secondary: "Sekundär", 
      ghost: "Geist",
      danger: "Gefahr",
      success: "Erfolg",
      disabled: "Deaktiviert",
      loading: "Lädt"
    },
    
    form: {
      title: "Formularelemente",
      input: "Eingabefeld",
      select: "Auswahlfeld",
      switch: "Schalter"
    },
    
    badges: {
      title: "Abzeichen",
      default: "Standard",
      secondary: "Sekundär",
      success: "Erfolg",
      warning: "Warnung",
      error: "Fehler",
      mint: "Minze",
      rose: "Rose",
      outline: "Umriss"
    },
    
    alerts: {
      title: "Warnungen",
      info: {
        title: "Information",
        description: "Dies ist eine Informationswarnung."
      },
      success: {
        title: "Erfolg",
        description: "Dies ist eine Erfolgswarnung."
      },
      warning: {
        title: "Warnung", 
        description: "Dies ist eine Warnmeldung."
      },
      error: {
        title: "Fehler",
        description: "Dies ist eine Fehlerwarnung."
      }
    }
  },
  
  code: {
    title: "Code-Beispiele",
    darkMode: {
      title: "Dark Mode Implementierung",
      example: "className=\"bg-white dark:bg-dark-card text-gray-900 dark:text-white\""
    }
  }
} 